import script from "./groupInfo.vue?vue&type=script&setup=true&name=GroupInfo&lang=js"
export * from "./groupInfo.vue?vue&type=script&setup=true&name=GroupInfo&lang=js"

import "./groupInfo.vue?vue&type=style&index=0&id=6ac30e94&scoped=true&lang=css"

import exportComponent from "/Users/nasinet/hujing_pro/hj_pro_h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ac30e94"]])

export default __exports__